import React from "react"
import {
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
} from "@mui/material"

const COUNTRIES = [
  { code: "US", label: "USA", flag: "🇺🇸" },
  { code: "IL", label: "Israel", flag: "🇮🇱" },
] as const

type CountryCode = (typeof COUNTRIES)[number]["code"];

export function CountrySingleSelect({
  type,
  value,
  onChange,
  t,
}: {
  type: string;
  value: CountryCode | null;
  onChange: (v: CountryCode | null) => void;
  t: (k: string) => string;
}) {
  if (type !== "profiler") return null

  return (
    <FormControl fullWidth>
      <FormLabel required>{t("field.label.countries")}</FormLabel>

      <FormGroup sx={{ mt: 1, gap: 0.5 }}>
        {COUNTRIES.map((c) => (
          <FormControlLabel
            key={c.code}
            control={
              <Checkbox
              checked={value === c.code}
              onChange={() => onChange(value === c.code ? null : c.code)}
              />
            }
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <span style={{ fontSize: 18 }}>{c.flag}</span>
                <span>{c.label}</span>
              </Box>
            }
          />
        ))}
      </FormGroup>
    </FormControl>
  )
}
